import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { AffAuthProvider } from "./context/AffAuthContext";
import { WebSocketProvider } from "./context/WebSocketContext";
import { Toaster } from "./components/ui/sonner";
import GlobalFooter from "./components/GlobalFooter";
import LandingPage from "./pages/LandingPage";
import VeloxLanding from "./pages/VeloxLanding";
import LegalPage from "./pages/legal/LegalPage";
import LoginPage from "./pages/LoginPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import AuthCallback from "./pages/AuthCallback";
import Dashboard from "./pages/Dashboard";
import AffLoginPage from "./pages/AffLoginPage";
import AffAuthCallback from "./pages/AffAuthCallback";
import AffDashboard from "./pages/AffDashboard";
import { ThemeProvider } from "./context/ThemeContext";

function AdminRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route path="/dashboard" element={<Dashboard />} />
      {/* Safe fallback so unknown admin paths never render blank */}
      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  );
}

function AffiliateRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AffAuthCallback />;
  }
  return (
    <Routes>
      <Route path="/affiliate/login" element={<AffLoginPage />} />
      <Route path="/affiliate/dashboard" element={<AffDashboard />} />
      {/* Partner referral link entry point — renders the same login page
          which auto-switches to the signup wizard when ?ref= is present */}
      <Route path="/affiliate/signup" element={<AffLoginPage />} />
      {/* /affiliate (no suffix) and any unknown subpath → safe fallback */}
      <Route path="/affiliate" element={<Navigate to="/affiliate/login" replace />} />
      <Route path="/affiliate/*" element={<Navigate to="/affiliate/login" replace />} />
    </Routes>
  );
}

function AppRouter() {
  const location = useLocation();

  // Root landing page (new 3D marketing)
  if (location.pathname === "/" && !location.hash?.includes("session_id=")) {
    return <VeloxLanding />;
  }

  // Legacy two-card portal
  if (location.pathname === "/portal") {
    return <LandingPage />;
  }

  // Legal pages (terms, privacy, refund, services)
  if (location.pathname.startsWith("/legal/")) {
    return (
      <Routes>
        <Route path="/legal/:doc" element={<LegalPage />} />
      </Routes>
    );
  }

  // Affiliate routes
  if (location.pathname.startsWith("/affiliate")) {
    return (
      <AffAuthProvider>
        <AffiliateRouter />
      </AffAuthProvider>
    );
  }

  // Admin routes
  return (
    <AuthProvider>
      <WebSocketProvider>
        <AdminRouter />
      </WebSocketProvider>
    </AuthProvider>
  );
}

function App() {
  return (
    <div className="App">
      <ThemeProvider>
        <BrowserRouter>
          <div className="min-h-screen flex flex-col">
            <div className="flex-1">
              <AppRouter />
            </div>
            <GlobalFooter />
          </div>
          <Toaster
            position="top-right"
            richColors
            toastOptions={{
              style: {
                background: "#1c2541",
                border: "1px solid rgba(255,255,255,0.1)",
                color: "#fff",
              },
            }}
          />
        </BrowserRouter>
      </ThemeProvider>
    </div>
  );
}

export default App;
